// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3lFiG","name":"Header_name__33BQG","birthday":"Header_birthday__1wDDv","skeleton":"Header_skeleton__ByxEE"};